import { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-premium'
import React from 'react'
import { Lead, User } from 'types'
import MassUpdateLeadsComponents from '../MassUpdateComponents/MassUpdateLeadsComponents'
import { FloatingActionBar } from '../shared'

interface LeadsGridFooterProps {
  users: User[]
  selectedData: Lead | null
  selectedMassData: Lead[]
  setSelectedMassData: React.Dispatch<React.SetStateAction<Lead[]>>
  massUpdateData: any
  rowSelectionModel: GridRowSelectionModel
  rowCount: number
  onChange: (e: any) => void
  onUpdate: (massUpdateData: any, rowSelectionModel: GridRowSelectionModel) => void
  onClear: () => void
  onClickDelete: (event: React.MouseEvent<HTMLElement>, rowSelectionModel: GridRowSelectionModel) => void
  onClickMassDelete: (
    rowSelectionModel: GridRowSelectionModel,
    setSelectedMassData: React.Dispatch<React.SetStateAction<Lead[]>>
  ) => void
  onDelete: (setIsDeleting: React.Dispatch<React.SetStateAction<boolean>>) => void
  onMassDelete: (
    rowSelectionModel: GridRowSelectionModel,
    setRowSelectionModel: React.Dispatch<React.SetStateAction<GridRowSelectionModel>>
  ) => void
  isDeleting: boolean
  onClosePopover: () => void
  leads: Lead[] | []
  anchorEl: HTMLElement | null
  customPosition?: { top: number; left: number } | null
  onCloseMassDeletePopover: () => void
  isMassDeleteOpen: boolean
  selectionIds?: GridRowId[]
  selectionCount?: number
}

export const LeadsGridFooter: React.FC<LeadsGridFooterProps> = ({
  users,
  selectedData,
  selectedMassData,
  setSelectedMassData,
  massUpdateData,
  rowSelectionModel,
  rowCount,
  onChange,
  onUpdate,
  onClear,
  onClickDelete,
  onClickMassDelete,
  onDelete,
  onMassDelete,
  isDeleting,
  onClosePopover,
  leads = [],
  anchorEl,
  customPosition,
  onCloseMassDeletePopover,
  isMassDeleteOpen,
}) => {
  const isVisible = rowSelectionModel && Array.from(rowSelectionModel?.ids).length > 0

  return (
    <FloatingActionBar visible={isVisible} onClose={onClosePopover}>
      <MassUpdateLeadsComponents
        users={users}
        selectedData={selectedData}
        selectedMassData={selectedMassData}
        setSelectedMassData={setSelectedMassData}
        massUpdateData={massUpdateData}
        rowSelectionModel={rowSelectionModel}
        rowCount={rowCount}
        onChange={onChange}
        onUpdate={onUpdate}
        onClear={onClear}
        onClickDelete={onClickDelete}
        onClickMassDelete={onClickMassDelete}
        onDelete={onDelete}
        onMassDelete={onMassDelete}
        isDeleting={isDeleting}
        onClosePopover={onClosePopover}
        leads={leads}
        anchorEl={anchorEl}
        onCloseMassDeletePopover={onCloseMassDeletePopover}
        isMassDeleteOpen={isMassDeleteOpen}
        customPosition={customPosition}
      />
    </FloatingActionBar>
  )
}
